var _linearGradient, _path, _path2, _path3, _path4, _linearGradient2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    clipRule: "evenodd",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "pg10I3OeSC0NOv22QZ6aWa",
    x1: -209.942,
    x2: -179.36,
    y1: -3.055,
    y2: 27.526,
    gradientTransform: "translate(208.979 6.006)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55adfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#438ffd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pg10I3OeSC0NOv22QZ6aWa)",
    d: "M39.001,13.999v27c0,1.105-0.896,2-2,2h-26 c-1.105,0-2-0.895-2-2v-34c0-1.104,0.895-2,2-2h19l2,7L39.001,13.999z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.999,18.001v2.999 h17.002v-2.999H15.999z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.001,24.001v2.999 h17.002v-2.999H16.001z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.999,30.001v2.999 h12.001v-2.999H15.999z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "pg10I3OeSC0NOv22QZ6aWb",
    x1: -197.862,
    x2: -203.384,
    y1: -4.632,
    y2: 0.89,
    gradientTransform: "translate(234.385 12.109)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#427fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c52bb"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pg10I3OeSC0NOv22QZ6aWb)",
    d: "M30.001,13.999l0.001-9l8.999,8.999L30.001,13.999z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocs);
export default __webpack_public_path__ + "static/media/google-docs.555fd409.svg";
export { ForwardRef as ReactComponent };